import axios from 'axios'
import { Message } from 'element-ui'
import { getCookie, delCookie, setCookie } from 'common/js/mUtils'
import router from 'src/router/index.js'
/* http request 拦截器 客户端发起请求 可以统一设置拦截器 可以统一设置请求头 */
axios.interceptors.request.use( // request 是表示在发送请求前进行统一的拦截操作 发送请求前要做的东西
  config => {
    // 判断是否存在token 如果存在的话则每个http。header 都加上 token
    let token = getCookie('u_uuid_token')
    if (token) {
      config.headers.Authorization = `token ${token}`
    }
    return config
  },
  err => { // 请求发生错误时的统一进行处理
    Message.error({message: '请求超时!'})
    return Promise.resolve(err)
  })
// http response 拦截器 服务器端响应也可以设置拦截，统一响应
axios.interceptors.response.use(data => { // response 服务器响应返回的数据  统一在回应响应的成功的函数中 这个代表返回的是没有错误的
  let token = getCookie('u_uuid_token') // 从中获取token 使用的是我们封装获取token的函数
  if (token) {
    let tokenTime = Number(getCookie('u_uuid_time'))
    let newTime = new Date().getTime() // 在设置新的taken的时候 把获取的时间也存在token 中 这样在获取token的可用来判断token 的时间
    if (newTime - tokenTime >= 10 * 60 * 1000 && newTime - tokenTime <= 15 * 60 * 1000) {
      postRequest('/diaodu/return_token.php', {}).then(res => {
        console.log(res)
        setCookie('u_uuid_time', newTime) // 设置token 在将要过期的用token换取新的token
        setCookie('u_uuid_token', res.data.token)
      })
    }
    if (newTime - tokenTime >= 15 * 60 * 1000) { // 如果超过15分钟没有在发送请求之后发起请求的后得到的响应是清除cookie
      delCookie('u_uuid_token') // 删除token
      delCookie('u_uuid_time')
    }
  }
  return data
},
err => {
  console.log(err)
  if (err.response) {
    switch (err.response.status) {
      case 401:
        // 返回401 清除token信息并跳转到登录页面 返回401的时候token已经失效 需要重新登录获取token 返回401 代表 token已经过期 没有授权
        delCookie('u_uuid_token')
        delCookie('u_uuid_time')
        router.replace({
          path: '/login'
        })
    }
  }
  if (err.response.status === 504 || err.response.status === 404) {
    Message.error({message: '服务器被吃了⊙﹏⊙∥'})
  } else if (err.response.status === 403) {
    Message.error({message: '权限不足,请联系管理员!'})
  } else if (err.response.status === 401) {
    /* 不做处理 */
  } else {
    Message.error({message: '未知错误!'})
  } return Promise.resolve(err)
})
const base = process.env.API_ROOT
export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    /* transformRequest: [ // 对请求的data可以随时处理
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ], */
    headers: { 'Content-Type': 'application/json' }
  })
}
// 封装上传文件的函数
export const uploadFileRequest = (url, params) => { // 上传文件发送请求
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: `${base}${url}` })
}
// 封装get请求
export const getRequest = (url) => { return axios({ method: 'get', url: `${base}${url}` }) }
/* 封装下载的函数 */
export const downloadRequest = (url, params) => { // 封装下载文件的函数
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    responseType: 'blob',
    headers: { 'Content-Type': 'application/json' }
  })
}



// WEBPACK FOOTER //
// ./src/common/js/http.js